import cns from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HeaderAwardsCount from '../../../client/components/widgets/CompositePageWidgets/Header/HeaderAwardsCount';
import HeaderContentCount from '../../../client/components/widgets/CompositePageWidgets/Header/HeaderContentCount';
import { postPeerRecommendations } from '../../actions/index';
import Image from '../../components/Image';
import RecommendationModal from '../../components/modals/RecommendationModal';
import RichTextDisplay from '../../components/RichTextDisplay';
import VerbButton, { VERB_BUTTON_TYPE } from '../../components/VerbButton';
import VerbHeading from '../../components/VerbHeading';
import { attachCloudinaryOptionsToImageSource, IMAGE_PROPS } from '../../utils/ImageUtils';
import { makeBannerBackgroundStyle } from '../../utils/StylingUtils';

export class CollectionBanner extends Component {
    static propTypes = {
        loading: PropTypes.bool,
        contentLoading: PropTypes.bool,
        memberProfiles: PropTypes.array,
        collection: PropTypes.object,
        history: PropTypes.object,
        createUserCollection: PropTypes.func,
        setCollectionState: PropTypes.func,
        userCollection: PropTypes.object,
        handleDelayedCreateLearningAssetsForUserCollection: PropTypes.func,
        userLearningAssets: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        collectionContent: PropTypes.array,
        postPeerRecommendations: PropTypes.func,
        teamsById: PropTypes.object,
        loggedInUser: PropTypes.object,
        loggedInUserCompany: PropTypes.object,
        // eslint-disable-next-line react/no-unused-prop-types
        intl: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            buttonDisabled: false,
            recommendationModalOpen: false
        };
    }

    _makeBannerImageProps = (collection = {}, imageProps = {}) => {
        const {
            intl: { formatMessage },
            userCollection
        } = this.props;
        const hasCollectionBannerImage = !!collection.coverImageUrl;

        let backgroundBannerStyle;
        if (hasCollectionBannerImage) {
            const backgroundUrl = attachCloudinaryOptionsToImageSource(collection.coverImageUrl, {
                color: '000000',
                colorize: 40,
                w: 3000
            });
            backgroundBannerStyle = makeBannerBackgroundStyle(backgroundUrl);
        }

        if (userCollection && (userCollection.percentComplete === 100 || userCollection.status === 'COMPLETED')) {
            return {
                textProp: {
                    fontFamily: 'Avenir-Bold.ttf',
                    fontWeight: (imageProps.dimension.w * 0.072).toString(),
                    alignment: 'center',
                    textColor: 'FFFFFF',
                    textY: 10,
                    backgroundWidth: imageProps.dimension.w.toString(),
                    gravity: 'north',
                    message: formatMessage({ id: 'HEADING_COMPLETE', defaultMessage: 'COMPLETE' })
                },
                overlay: {
                    opacity: '60',
                    gravity: 'north',
                    dimension: {
                        h: imageProps.dimension.w * (0.18).toString(),
                        w: imageProps.dimension.w.toString()
                    },
                    overlayId: 'teal'
                },
                hasCollectionBannerImage,
                backgroundBannerStyle
            };
        }

        return {
            hasCollectionBannerImage,
            backgroundBannerStyle
        };
    };

    _handleSubscribeOnclick = () => {
        const { createUserCollection, history, setCollectionState } = this.props;
        this.setState({ buttonDisabled: true });
        return createUserCollection().then((createdCollection) => {
            if (createdCollection.content) {
                for (let i = 0; i < createdCollection.content.length; i += 1) {
                    const asset = createdCollection.content[i];
                    if (!asset.isCompleted) {
                        return history.push(`/workspace/${asset.userLearningAssetId}`, {
                            userCollection: {
                                id: createdCollection._id,
                                started: true
                            }
                        });
                    }
                }
            }
            return setCollectionState(createdCollection);
        });
    };

    _getCTAButton = () => {
        const { userCollection = {}, userLearningAssets } = this.props;
        const { buttonDisabled } = this.state;

        const length = userCollection.content ? userCollection.content.length : 0;

        let activityData = '';
        if (
            !userCollection ||
            !userCollection._id ||
            (!userCollection?.percentComplete && userCollection?.status !== 'IN_PROGRESS')
        ) {
            return (
                <VerbButton
                    textId={'BEGIN_COLLECTION_BUTTON_TEXT'}
                    defaultMessage={'BEGIN'}
                    disabled={buttonDisabled}
                    onClick={this._handleSubscribeOnclick}
                />
            );
        }

        if (userCollection.percentComplete === 100 && userCollection.status === 'COMPLETED') {
            activityData = {
                pathname: `/workspace/${userCollection.content[0].userLearningAssetId}`,
                state: {
                    userCollection: {
                        id: userCollection._id,
                        started: false
                    }
                }
            };
            return (
                <VerbButton
                    textId={'BUTTON_REVIEW'}
                    defaultMessage={'REVIEW'}
                    onClick={this._getClickHandlerForActionButton(activityData)}
                />
            );
        }

        if (
            (userCollection.percentComplete && userCollection.percentComplete !== 100) ||
            userCollection.status === 'IN_PROGRESS'
        ) {
            for (let i = 0; i < length; i += 1) {
                const currentAsset = userLearningAssets[userCollection.content[i].userLearningAssetId];
                if (currentAsset && !currentAsset.isCompleted && !activityData) {
                    activityData = {
                        pathname: `/workspace/${userCollection.content[i].userLearningAssetId}`,
                        state: {
                            userCollection: {
                                id: userCollection._id,
                                started: false
                            }
                        }
                    };
                }
            }

            return (
                <VerbButton
                    textId={'BUTTON_CONTINUE'}
                    defaultMessage={'CONTINUE'}
                    onClick={this._getClickHandlerForActionButton(activityData)}
                />
            );
        }

        return null;
    };

    _renderRecommendButton = () => (
        <VerbButton
            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
            onClick={this._toggleRecommendationModal}
            textId={'RECOMMEND'}
            fontAwesomeIcon={'fa-paper-plane'}
            defaultMessage={'RECOMMEND'}
            className={'recommend-button'}
        />
    );

    _referenceGuides = (resources) => {
        const uploadedPdfRefGuides = [];
        (resources || []).forEach((item) => {
            if (item.url.split('.').includes('pdf') || item.url.split('.').includes('PDF')) {
                uploadedPdfRefGuides.push(item.url.split(' ').join('+'));
            }
        });

        return uploadedPdfRefGuides;
    };

    _getClickHandlerForActionButton = (href) => {
        const { userCollection, handleDelayedCreateLearningAssetsForUserCollection, history } = this.props;

        if (!userCollection || !userCollection.content) {
            return () => {};
        }

        if (!userCollection.percentComplete && !userCollection.content[0].userLearningAssetId) {
            return () => handleDelayedCreateLearningAssetsForUserCollection(userCollection._id);
        }
        return () => history.push(href);
    };

    _toggleRecommendationModal = () => {
        this.setState((prev) => ({ recommendationModalOpen: !prev.recommendationModalOpen }));
    };

    renderSecondaryStats = () => {
        const { contentLoading, memberProfiles, collection = {}, collectionContent } = this.props;

        return (
            <div className={cns('header-stats-row row header-collection-stats')}>
                <HeaderContentCount
                    contentLoading={contentLoading}
                    currentCollection={collection}
                    userCollectionContent={collectionContent}
                />
                {/* <HeaderAwardsCount
                    contentLoading={contentLoading}
                    collection={collection}
                    memberProfiles={memberProfiles}
                    isCollectionBanner={true}
                /> */}
            </div>
        );
    };

    render() {
        const {
            collection = {},
            loading,
            postPeerRecommendations,
            teamsById,
            loggedInUser,
            loggedInUserCompany,
            isAccountOwner,
            isVerbAdmin
        } = this.props;

        const imageProps = IMAGE_PROPS.collectionHeadingImageCloudinary;

        const { backgroundBannerStyle, hasCollectionBannerImage, textProp, overlay } = this._makeBannerImageProps(
            collection,
            imageProps
        );

        return (
            <div
                style={backgroundBannerStyle}
                className={cns(`header-container`, { 'team-background-2': !hasCollectionBannerImage })}
            >
                <RecommendationModal
                    parentEntity={collection}
                    teamsById={teamsById}
                    isOpen={this.state.recommendationModalOpen}
                    onClose={this._toggleRecommendationModal}
                    parentId={collection._id}
                    onSend={postPeerRecommendations}
                    companyId={loggedInUser.companyId}
                    company={loggedInUserCompany}
                    loggedInUser={loggedInUser}
                    currentUserEmail={loggedInUser.email}
                    parentType={'COLLECTION'}
                    isAccountOwner={isAccountOwner}
                    isVerbAdmin={isVerbAdmin}
                />
                <div className={'container'}>
                    <div className={'row align-items-center'}>
                        <div className={'col-12 col-md-9'}>
                            <div className={'row'}>
                                <div className={'col-sm-12 header-containing-container'}>
                                    <div className={'row'}>
                                        <div className={'header-thumbnail col-6 col-sm-5 col-lg-4'}>
                                            <Image
                                                src={collection.thumbnailImageUrl || ''}
                                                dimension={imageProps.dimension}
                                                cloudinaryCrop={imageProps.cloudinaryCrop}
                                                className={'collection-thumbnail'}
                                                quality={{ q: 100 }}
                                                textProp={textProp}
                                                overlay={overlay}
                                            />
                                        </div>
                                        <div className={'header-collection-content col-6 col-sm-7'}>
                                            <div className={'row h-100'}>
                                                <div className={cns('header-collection-info col-12', { loading })}>
                                                    <VerbHeading
                                                        hNumber={6}
                                                        messageId={
                                                            collection.type === 'STANDARD'
                                                                ? 'HEADING_CERTIFIED_COLLECTION'
                                                                : 'HEADING_COLLECTION'
                                                        }
                                                        defaultMessage={
                                                            collection.type === 'STANDARD'
                                                                ? 'CERTIFIED PATH'
                                                                : 'PATH'
                                                        }
                                                    />
                                                    <div className={'header-collection-name'}>
                                                        {(collection.name || '').toUpperCase()}
                                                    </div>
                                                    <div
                                                        className={cns('header-description-text d-none d-md-block', {
                                                            loading: loading && !collection._id
                                                        })}
                                                    >
                                                        <p>
                                                            <RichTextDisplay htmlToDisplay={collection.subtitle} />
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className={'col-12 header-info-secondary-stats stats-small-display'}
                                                >
                                                    {this.renderSecondaryStats()}
                                                </div>
                                                <div
                                                    className={
                                                        'd-none d-md-block col-12 collection-header-buttons align-self-end'
                                                    }
                                                >
                                                    {this._getCTAButton()}
                                                    {/* {this._renderRecommendButton()} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'collection-header-buttons-mobile visible-xs'}>
                                {this._getCTAButton()}
                                {/* {this._renderRecommendButton()} */}
                            </div>
                        </div>
                        <div className={'col-12 col-sm-3 header-info-secondary-stats stats-normal-display'}>
                            {this.renderSecondaryStats()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    const {
        auth: { loggedInUser, loggedInUserCompanyId, isVerbAdmin, isAccountOwner },
        userLearningAssets,
        userCollections,
        companies,
        teams
    } = state;

    const userCompany = companies && companies.byId && companies.byId[loggedInUser.companyId];
    const loading = userLearningAssets.loading && userCollections.loading;
    const loggedInUserCompany = state.companies && state.companies.byId && state.companies.byId[loggedInUserCompanyId];

    return {
        loggedInUser,
        loggedInUserCompany,
        userLearningAssets: userLearningAssets.byId,
        loading,
        isVerbAdmin,
        userCompany,
        isAccountOwner,
        teamsById: teams.byId
    };
};

export const mapDispatchToProps = (dispatch) => ({
    postPeerRecommendations: (params) => dispatch(postPeerRecommendations(params))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CollectionBanner)));
